module.exports = __webpack_public_path__ + "static/media/rebirth_32.f98fad07.jpg";